module.exports = ".alarm {\n  background-color: #ff8f00 !important;\n  color: #ffffff !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/position-history/position-history.component.css
// module id = ./src/app/position-history/position-history.component.css
// module chunks = main